import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DragHandleHoverContainerContext = /*#__PURE__*/createContext({
  renderGripOnHover: false
});
export const DragHandleHoverContainerProvider = ({
  renderGripOnHover,
  children
}) => {
  return /*#__PURE__*/_jsx(DragHandleHoverContainerContext.Provider, {
    value: {
      renderGripOnHover
    },
    children: children
  });
};
export const useDragHandleHoverContainerContext = () => {
  return useContext(DragHandleHoverContainerContext);
};